import type { TMake } from '@src-common/api/definitions/w4d-cars-types';

import { useModelConfig } from './useModelConfig';

const useGenerations = (make?: TMake, model?: string) => {
  const modelConfig = useModelConfig(make, model);

  if (!modelConfig || !model) {
    return [];
  }

  return modelConfig.generations.map(generation => ({ title: generation, value: generation }));
};

export { useGenerations };
